import { useState, useCallback } from "react";
import { ASC, DESC } from "../utils/constants/appConstants";

// Clicking a column cycles first order -> opposite order -> unsorted
const getNextOrder = (current, defaultFirstOrder) => {
  const firstOrder = defaultFirstOrder === DESC ? DESC : ASC;
  const secondOrder = firstOrder === DESC ? ASC : DESC;

  if (current === firstOrder) {
    return secondOrder;
  }
  if (current === secondOrder) {
    return null;
  }
  return firstOrder;
};

export const useColumnSort = (
  initialOrders = {},
  { defaultFirstOrder = ASC } = {}
) => {
  const [columnOrders, setColumnOrders] = useState(initialOrders);

  const handleSort = useCallback(
    (columnId) => {
      setColumnOrders((prev) => {
        const current = prev[columnId];

        const nextOrder = getNextOrder(current, defaultFirstOrder);

        const newOrders = Object.keys(prev).reduce((acc, key) => {
          acc[key] = key === columnId ? nextOrder : null;
          return acc;
        }, {});

        return newOrders;
      });
    },
    [defaultFirstOrder]
  );

  return { columnOrders, handleSort };
};
